import React from 'react'
import { useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'

import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import Hidden from '@material-ui/core/Hidden'

import SideMenu from 'components/layout/SideMenu'
import AppBarMenu from 'components/layout/AppBarMenu'
import LinkMenu from 'components/layout/LinkMenu'
import Snackbar from 'components/system/Snackbar'
import GlobalLoading from 'components/system/GlobalLoading'

import authSelectors from 'store/selectors/auth'
import networkSelectors from 'store/selectors/network'
import routerSelectors from 'store/selectors/router'

import {
  USER_MENU,
  GUEST_MENU,
} from 'menus'

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%'
  },
  appbar: {
    width: '100%',
    flexGrow: 1,
    flex: 1,
    position: 'fixed',
    zIndex: 1000,
  },
  toolbar: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    backgroundColor: '#fff',
    height: '80px'
  },
  flex: {
    flex: 1,
  },
  content: ({embedded}) => ({
    height: '100%',
    paddingTop: embedded ? '0px' : '80px',
  }),
  logo: {
    height: '50px',
  },
}))

const Layout = ({
  children,
}) => {
  
  const user = useSelector(authSelectors.data)
  const globalLoading = useSelector(networkSelectors.globalLoading)
  const embedded = useSelector(authSelectors.embedded)

  const classes = useStyles({
    embedded,
  })

  const MENU = user ?
    USER_MENU :
    GUEST_MENU

  if(embedded) {
    return (
      <div className={ classes.root }>
        <div className={ classes.content }>
          { children }
        </div>
        <GlobalLoading
          loading={ globalLoading }
        />
        <Snackbar />
      </div>
    )
  }
    
  return (
    <div className={ classes.root }>
      <div className={ classes.appbar }>
        <AppBar position="static">
          <Toolbar className={ classes.toolbar }>
            <SideMenu 
              items={ MENU }
            />
            <div className={ classes.flex }>
              <img src="/img/logo.png" className={ classes.logo } />
            </div>
            <Hidden smDown>
              <LinkMenu
                items={ MENU }
              />
            </Hidden>
            <AppBarMenu
              items={ MENU }
            />
          </Toolbar>
        </AppBar>
      </div>
      <div className={ classes.content }>
        { children }
      </div>
      <GlobalLoading
        loading={ globalLoading }
      />
      <Snackbar />
    </div>
  )
}

export default Layout